import React from 'react'
import StepperWrapper from './components/StepperWrapper'
import {DialogContextProvider} from 'contexts/DialogContext'

export default function MainApp() {
  return (
    <DialogContextProvider>
      <StepperWrapper />
    </DialogContextProvider>
  )
}
